import { FunctionComponent, memo, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackUser } from "utilities/track-user";

import { IProps } from "./track-page-changes.types";
import "./track-page-changes.scss";
import { getCurrentPage } from "utilities-for/routes/get-current-page";

/**
 * Record when a user navigates to other pages for analytics purposes.
 * @returns Empty render.
 */
const TrackPageChanges: FunctionComponent<IProps> = () => {
    const location = useLocation();

    // Listen for page changes.
    useEffect(() => {
        // TODO: Check this with next react-router release as it might not work with optional parameters
        const pageName = getCurrentPage(location.pathname);
        if (typeof pageName !== "undefined") {
            trackUser("Page Load", { pageName }, true);
        }
    }, [location.pathname]);

    return null;
};

export default memo(TrackPageChanges);
